import { Tabs } from 'antd';
import React from 'react';
import {
  useGetPendingBiddersQuery,
  useGetPendingBuyersQuery,
  useGetPendingSellersQuery,
} from '../../../app/api/userApiSlice';
import BidderTable from '../containers/BidderTable';
import BuyerTable from '../containers/BuyerTable';
import SellerTable from '../containers/SellerTable';

const ListPendingUser: React.FC = () => {
  const { data: pendingSellers, isLoading: isSellerLoading } = useGetPendingSellersQuery();
  const { data: pendingBuyers, isLoading: isBuyerLoading } = useGetPendingBuyersQuery();
  const { data: pendingBidders, isLoading: isBidderLoading } = useGetPendingBiddersQuery();

  return (
    <Tabs defaultActiveKey='1'>
      <Tabs.TabPane tab='Seller Registration Request' key='1'>
        <SellerTable sellers={pendingSellers} isLoading={isSellerLoading} />
      </Tabs.TabPane>
      <Tabs.TabPane tab='Buyer Registration Request' key='2'>
        <BuyerTable buyers={pendingBuyers} isLoading={isBuyerLoading} />
      </Tabs.TabPane>
      <Tabs.TabPane tab='Auction Registration Request' key='3'>
        <BidderTable bidders={pendingBidders} isLoading={isBidderLoading} />
      </Tabs.TabPane>
    </Tabs>
  );
};

export default ListPendingUser;
